import React, { useEffect, useState } from 'react';
import { View, Text, Linking } from 'react-native';
import { ListItem } from '../atoms/listitem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import variables from '../atoms/variables.json';
import { TextInput } from '../atoms/textinput';
import PersonIcon from '@material-ui/icons/Person';
import BottomButton from '../atoms/bottomButton';
import ContactCard from '../atoms/contactCard';
import ToolTip from '../atoms/ToolTip';
import Checkbox from '@material-ui/core/Checkbox';
import PropertyCard from '../atoms/PropertyCard';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import DOC_ICON from './../../../assets/svgIcons/OpenFlo/Documentation.svg';
import ProgressCircle from "./components/ProgressCircle"

import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  TlyfeButtonWrapper,
  FormContainer,
  SubHeading,
  RowContainer,
  TextBox,
  ButtonRowContainer,
} from './style';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
import { DocumentCard } from '../atoms/documentCard';
import BackComponent from '../atoms/backComponent';
import { useDispatch, useSelector } from 'react-redux';
// import { tenantActions, alertActions } from '_actions';
import ToggleComplete from '../atoms/toggleComplete';
// import Constant from 'config/Constant';
import CommanModal from './commanModal';
import OpenFlowModal from '../atoms/modal';

// import { useHistory } from 'react-router-dom';
import SaveandContinueModal from '../atoms/SaveandContinueModal';
import Container from '../atoms/Container/Container';
import DrawerHoc from '../../../../components/drawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { tenantActions } from '../../redux/tenant.actions';
import STRINGS from '../../redux/strings';
import { showErrorToast, showSuccesToast } from '../helpers';
import { navigate } from '../../../../navigation/RootNavigation';
import CertificatesScreen from './components/certScreen';
import DocStatusTable from './DocStatusTable';
import LandlordCard from './components/LandlordCard';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MuiButton,
} from '@material-ui/core';
let landlordModal = {
  title: '',
  name: '',
  first_name: '',
  last_name: '',
  license_number: '',
  is_lead: false,
  correspondece_address: null,
  post_code: '',
  email: '',
  number: '',
  is_england_address: true,
  number_england: '',
  correspondence_address_england: '',
  post_code_england: '',
  email_england: '',
  showForm: false,
};
const layoutType = getPlatformType();
const PropertyDocumentation = (props) => {
  const dispatch = useDispatch();
  const isPhone = layoutType === 'phone';
  const [flowId, setFlowId] = React.useState(null);
  const [price, setPrice] = React.useState({
    gas_safety_certificate: 0,
    epc: 0,
    eicr: 0,
    pat: 0,
  });

  const [showModal, setModal] = React.useState(null);
  const [showNoticeModal, setShowNoticeModal] = React.useState(false);
  const [gasSafteyCer, setGasSafetyCer] = React.useState(null);
  const [gasSafteyCerReq, setGasSafetyCerReq] = React.useState(false);
  const [epcCerReq, setEpcCerReq] = React.useState(false);
  const [eicCerReq, setEicCerReq] = React.useState(false);
  const [patCerReq, setPatCerReq] = React.useState(false);
  const [showAgain, setShowAgain] = React.useState(false);
  const [epcCer, setEpcCer] = React.useState(null);
  const [eicCer, setEicCer] = React.useState(null);
  const [patCer, setPatCer] = React.useState(null);
  const [lisc, setLiscCer] = React.useState(null);
  const [gasSafteyCerIsSeen, setGasSafetyCerIsSeen] = React.useState(false);
  const [epcCerIsSeen, setEpcCerIsSeen] = React.useState(false);
  const [eicCerIsSeen, setEicCerIsSeen] = React.useState(false);
  const [patCerIsSeen, setPatCerIsSeen] = React.useState(false);
  const [liscIsSeen, setLiscCerIsSeen] = React.useState(false);
  const [showAddLandLord, setShowAddLandLord] = React.useState(false);
  const [editingLandlordIndex, setEditingLandlordIndex] = React.useState(null);
  const [showDeleteLandlordModal, setShowDeleteLandlordModal] = React.useState(false);
  const [selectedLandlordToDelete, setSelectedLandlordToDelete] = React.useState(null);
  const [fieldsValue, setFieldValues] = React.useState(landlordModal);
  const [landlords, setLandlords] = React.useState([]);
  const [closePopup, setClosePopup] = React.useState(false);
  const [userSelection, setUserSelection] = React.useState(null);
  const [is_show_document_popup, setIs_show_document_popup] = React.useState(false);
  const [mailToUpdateAsLead, setMailToUpdateAsLead] = React.useState('');
  const [nameError, setNameError] = React.useState('');
  const [showSuccessModal, setSuccessModal] = React.useState(false);

  const globalState = useSelector((state) => state?.tenant?.flowIdInfo);
  const LoginState = useSelector((state) => state?.Login?.userDetails);



  const lisenceData = useSelector((state) => state?.tenant?.lisenceData);
  const priceData = useSelector((state) => state?.tenant?.flowIdInfo?.product_prices);
  const [modalState, setModalState] = React.useState({ send_to_tenant: true });
  useEffect(() => {
    if (globalState) {
      setModalState({
        send_to_tenant: globalState?.is_send_document_details,
      });
    }
  }, [globalState?.is_send_document_details]);

  const convertToArray = (...certs) => certs.filter(cert => cert && Object.keys(cert).length > 0);
  const _save = (back, sendDocToTeanant, data = null) => {
    let obj = {
      certificates: convertToArray(gasSafteyCer, epcCer, eicCer, patCer, lisc),
      sendDocToTeanant: sendDocToTeanant,
      flow_id: flowId,
    };
    dispatch(tenantActions.saveCer(obj, flowId, back, (data) => {
      setSuccessModal(false)
    }));
  };
  console.log("success midal", showSuccessModal)
  useEffect(() => {
    console.log("props", props)
    if (props?.route?.params) {
      if (props?.route?.params?.id) {
        setFlowId(props?.route?.params?.id);
        fetchFlows()
      }
    }
  }, []);
  const fetchFlows = () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
    dispatch(tenantActions.buyCer(props?.route?.params?.id))
  }
  useEffect(() => {
    setIs_show_document_popup(globalState?.is_show_document_popup);
  }, [globalState?.is_show_document_popup]);
  useEffect(() => {
    if (globalState?.open_flow_landlords && globalState?.open_flow_landlords?.length) {
      setLandlords(globalState?.open_flow_landlords)
    } else {
      setLandlords([])
    }
  }, [globalState]);

  useEffect(() => {
    let newData = price;
    if (priceData && priceData.length) {
      priceData.map((data) => {
        newData[data?.product_description] = data.product_price;
      });
    }
    setPrice(newData);
  }, [priceData]);

  useEffect(() => {
    if (globalState?.open_flow_certificates) {
      const gasCertificates1 = globalState?.open_flow_certificates.filter(
        (certificate) => certificate.certificate_type == 'certificates_gas'
      )
      const epcCertificates1 = globalState?.open_flow_certificates.filter(
        (certificate) => certificate.certificate_type == 'certificates_epc'
      )
      const patCertificates1 = globalState?.open_flow_certificates.filter(
        (certificate) => certificate.certificate_type == 'certificates_pat'
      )
      const eicrCertificates1 = globalState?.open_flow_certificates.filter(
        (certificate) => certificate.certificate_type == 'certificates_eicr'
      )
      const licenseCertificates1 = globalState?.open_flow_certificates.filter(
        (certificate) => certificate.certificate_type == 'licensing'
      )
      console.log("epcCertificates1", epcCertificates1)
      if (eicrCertificates1 && eicrCertificates1.length) {
        setEicCer(eicrCertificates1[0]);

      } else {
        setEicCer(null);
      }
      if (epcCertificates1 && epcCertificates1.length) {
        setEpcCer(epcCertificates1[0])
      } else {
        setEpcCer(null);
      }

      if (gasCertificates1 && gasCertificates1.length) {
        setGasSafetyCer(gasCertificates1[0]);
      } else {
        setGasSafetyCer(null);
      }
      if (patCertificates1 && patCertificates1.length) {
        setPatCer(patCertificates1[0]);
      } else {
        setPatCer(null);
      }
      if (licenseCertificates1 && licenseCertificates1.length) {
        setLiscCer(licenseCertificates1[0]);
      } else {
        setLiscCer(null);
      }
    }
  }, [
    globalState?.open_flow_certificates
  ]);

  useEffect(() => {
    if (globalState?.certicicateRequests) {
      let { eicr, epc, gas, pat } = globalState?.certicicateRequests;
      if (eicr && eicr.length) {
        setEicCerReq(eicr[0]);
      }

      if (epc && epc.length) {
        setEpcCerReq(epc[0]);
      }

      if (gas && gas.length) {
        setGasSafetyCerReq(gas[0]);
      }

      if (pat && pat.length) {
        setPatCerReq(pat[0]);
      }
    }
  }, [globalState?.certicicateRequests]);

  const renderModal = (
    <>
      <Text style={{ fontWeight: '700', marginTop: 20, color: '#101828' }}>
        Have you clicked "save and send documents"?
      </Text>
      <Text style={{ fontWeight: '700', marginTop: 10, color: '#101828' }}>
        Remember, if you don't do this, your tenants do not receive the documents to thier tlyfe app.
      </Text>
      <View
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <Button
          type={userSelection === 'sentDocumnets' ? 'solid' : 'stripe'}
          title={"I've sent it"}
          type={'stripe'}
          style={{ borderColor: '#90C418', color: '#90C418' }}
          onClick={() => {
            setUserSelection('sentDocumnets');
            _save('backNavigation', true);
            setShowNoticeModal(false);
          }}
        />
        <Button
          type={userSelection === 'saveOnly' ? 'solid' : 'stripe'}
          title={"I'll send it later"}
          style={{ marginLeft: 30 }}
          type={'stripe'}
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
          onClick={() => {
            setUserSelection('saveOnly');
            _save('backNavigation', false);
            setShowAgain(false);
          }}
        />
      </View>

      <RowContainer
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Checkbox
            name="showPopup"
            checked={!is_show_document_popup}
            onChange={() => setIs_show_document_popup(!is_show_document_popup)}
            value={1}
            color="primary"
          />
          <Text style={{ color: '#000000' }}>Do not show again</Text>
        </View>

        <Button
          type="solid"
          title={"save"}
          style={{ marginLeft: 30 }}
          onClick={() => {
            if (userSelection === "sentDocumnets") {
              _save("backNavigation", true);
              setShowNoticeModal(false);
            } else if (userSelection === "saveOnly") {
              _save("backNavigation", false);
            }
          }}
        />
      </RowContainer>
      <Text style={{ color: '#000000' }}>Once you click this, you cannot undo this change.</Text>
    </>
  );

  const renderModalBodyforGas = (
    <CommanModal
      onSubmitted={() => setModal(false)}
      type={'gas'}
      initialCost={price?.gas_safety_certificate}
      minRange={2}
      flowID={flowId}
    />
  );
  const renderModalBodyforEPC = (
    <CommanModal
      onSubmitted={() => setModal(false)}
      type={'epc'}
      initialCost={price?.epc}
      minRange={1}
      flowID={flowId}
    />
  );
  const renderModalBodyforEICR = (
    <CommanModal
      onSubmitted={() => setModal(false)}
      type={'eicr'}
      initialCost={price?.eicr}
      minRange={1}
      flowID={flowId}
    />
  );
  const renderModalBodyforPAT = (
    <CommanModal
      onSubmitted={() => setModal(false)}
      type={'pat'}
      initialCost={price?.pat}
      minRange={1}
      flowID={flowId}
    />
  );

  const renderModalBodyLandloard = (data) => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <View style={{ width: '48%' }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Title: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '99%',
          }}
          containerStyles={{ width: '100%' }}
          value={data.title || ''}
        />
      </View>
      <View style={{ width: '48%' }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>First Name: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '99%',
          }}
          containerStyles={{ width: '100%' }}
          value={data.first_name || ''}
        />
      </View>
      <View style={{ width: '48%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Last Name: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '19%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.last_name || ''}
        />
      </View>
      <View style={{ width: '48%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Email: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.email?.toLowerCase() || ''}
        />
      </View>
      <View style={{ width: '48%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Contact Number: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.number || ''}
        />
      </View>
      <View style={{ width: '48%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Landlord Registration Number: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.license_number || ''}
        />
      </View>
      <View style={{ width: '48%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Post Code: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '49%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.post_code || ''}
        />
      </View>
      <View style={{ width: '100%', marginTop: 10 }}>
        <TextInput
          title={
            <>
              <Text style={{ fontWeight: '700' }}>Correspondence Address: </Text>
            </>
          }
          type={'row'}
          wrapperStyle={{
            width: '100%',
            marginTop: 20,
          }}
          containerStyles={{ width: '100%' }}
          value={data.correspondece_address || ''}
        />
      </View>
    </View>
  );

  const renderRemoveCardBody = (item, index) => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <Text style={{ color: '#111827', marginBottom: 16 }}>Do you wish to remove this ?</Text>
      <TlyfeButtonWrapper>
        <Button
          onClick={() => {
            let newArray = [...landlords];
            newArray.splice(index, 1);
            setLandlords(newArray);
            setClosePopup(false);
          }}
          title={'Yes'}
          type="stripe"
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setClosePopup(false);
          }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
      <br /> <br />
      <RowContainer>
        <Text style={{ color: '#111827' }}>Please Note</Text>
        <Text style={{ color: '#111827' }}> Once you remove this you cannot undo this change</Text>
      </RowContainer>
    </View>
  );
  const _onSave = () => { };

  const handleChange = (e, name) => {
    if (e.target.name == "number_england" || e.target.name == "number") {
      setFieldValues({ ...fieldsValue, [e.target.name]: e?.target?.value?.replace(/[^0-9]/g, '') });
    } else {
      setFieldValues({ ...fieldsValue, [e.target.name]: e.target.value });
    }

  };

  const renderModalBody = () => (
    <>
      <ButtonRowContainer style={{ marginTop: '5%', alignItems: 'baseline' }}>
        <Heading>Don't know if you need a licence or not, Check Here!</Heading>
        {lisenceData && lisenceData.length ? null : (
          <Button
            style={{ borderColor: '#90C418' }}
            // onClick={() => dispatch(tenantActions.CheckForLisence(flowId))}
            title={'Check'}
            type="stripe"
          />
        )}
      </ButtonRowContainer>

      {lisenceData && lisenceData.length ? (
        <>
          <ButtonRowContainer
            style={{
              marginTop: '2%',
              alignItems: 'flex-end',
              justifyContent: 'flex-start',
            }}
          >
            <Heading>Your Council: </Heading>
          </ButtonRowContainer>
          {lisenceData.map((data, index) => (
            <CardBox style={{ width: '70%', marginBottom: '2%' }} hasShadow={true} hasBorderRadius={true}>
              <View style={{ justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' }}>
                <Text style={{ marginTop: 5, fontSize: 14, color: '#101828' }}>{data?.name}</Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text
                    onPress={() => {
                      if (data?.license_portal) {
                        Linking.openURL(data.license_portal);
                      }
                    }}
                    style={{
                      marginTop: 5,
                      fontSize: 14,
                      fontWeight: 500,
                      color: variables.purple1,
                    }}
                  >
                    View
                  </Text>
                </View>
              </View>
            </CardBox>
          ))}
        </>
      ) : null}
    </>
  );
  const renderModalBodyEpc = () => (
    <>
      <ButtonRowContainer style={{ marginTop: '5%', alignItems: 'baseline' }}>
        <Heading>Don't know if this property already has an EPC? Check Here!</Heading>
      </ButtonRowContainer>
      <Button
        style={{ borderColor: '#90C418' }}
        onClick={() => {
          // const newWindow = window.open(Constant.EIC_URL, '_blank', 'noopener,noreferrer');
          if (newWindow) newWindow.opener = null;
        }}
        title={'Check'}
        type="stripe"
      />
    </>
  );
  const _addLandlord = () => {
    if (!fieldsValue.first_name) {
      showErrorToast('First name is Required');
    } else if (!fieldsValue.last_name) {
      showErrorToast('Last name is Required');
    }
    else if (!fieldsValue.number) {
      showErrorToast("Contact number is required")
    } else if (fieldsValue?.number?.length <= 7) {
      showErrorToast("Contact number must be more than 7 digits")
    }
    else if (landlords.length == 0 && !fieldsValue?.is_lead) {
      showErrorToast('Please add the lead landlord first!')
    } else {
      if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(fieldsValue.email)) {
        const landlordPayload = {
          ...fieldsValue,
          correspondece_address: fieldsValue.correspondece_address ? fieldsValue.correspondece_address : null,
        };

        if (editingLandlordIndex !== null) {
          const updatedLandlords = [...landlords];
          updatedLandlords[editingLandlordIndex] = {
            ...updatedLandlords[editingLandlordIndex],
            ...landlordPayload,
            edit_this_tenant: true,
          };
          const updatedList = fieldsValue.is_lead
            ? MakeLeadFunct(updatedLandlords, fieldsValue?.email)
            : updatedLandlords;

          dispatch(tenantActions.addNRemovedLandlord({ landlords: updatedList }, flowId, () => {
            showSuccesToast("Landlord updated successfully!");
            setShowAddLandLord(false);
            setEditingLandlordIndex(null);
            setFieldValues(landlordModal);
            fetchFlows();
          }));
        } else {
          const updatedList = fieldsValue.is_lead
            ? MakeLeadFunct([...landlords, landlordPayload], fieldsValue?.email)
            : [...landlords, landlordPayload];

          dispatch(tenantActions.addNRemovedLandlord({ landlords: updatedList }, flowId, () => {
            showSuccesToast("Landlord added successfully!");
            setShowAddLandLord(false);
            setFieldValues(landlordModal);
            fetchFlows();
          }));
        }
      } else {
        showErrorToast('Invalid Email')
      }
    }
  };
  const _closeForm = () => {
    setShowAddLandLord(false);
    setEditingLandlordIndex(null);
    setFieldValues(landlordModal);
  };

  const handleEditLandlord = (landlordItem, index) => {
    setEditingLandlordIndex(index);
    setFieldValues({
      ...landlordModal,
      title: landlordItem.title || '',
      first_name: landlordItem.first_name || '',
      last_name: landlordItem.last_name || '',
      email: landlordItem.email || '',
      number: landlordItem.number || '',
      license_number: landlordItem.license_number || '',
      is_lead: Boolean(landlordItem.is_lead),
      correspondece_address: landlordItem.correspondece_address || landlordItem.address || '',
      post_code: landlordItem.post_code || '',
      is_england_address: landlordItem.is_england_address !== undefined ? landlordItem.is_england_address : true,
      open_flow_landlord_id: landlordItem.open_flow_landlord_id,
      openflow_id: landlordItem.openflow_id,
      edit_this_tenant: true,
    });
    setShowAddLandLord(true);
  };

  const displayAddLandLord = () => (
    <CardBox
      style={{
        ...sectionCardStyle,
        marginTop: 24,
      }}
      hasShadow={true}
      hasBorderRadius={true}
      backColor="#FFFFFF"
      borderColor="#E4EAF5"
    >
      <View style={sectionHeaderStyle}>
        <View style={titleBlockStyle}>
          <SubHeading style={{ color: variables.purple, marginTop: 0, marginBottom: 0, fontSize: 18 }}>
            {editingLandlordIndex !== null ? 'Edit Landlord' : 'Add Landlord'}
          </SubHeading>
          <Text style={helperTextStyle}>
            Capture the landlord’s contact details, registration number and address in one place.
          </Text>
        </View>
        <Text style={badgeStyle}>Required fields marked with *</Text>
      </View>

      <View style={gridStyle}>
        <View style={fieldWrapStyle}>
          <Text style={labelStyle}>Title</Text>
          <Select
            value={fieldsValue?.title}
            style={{
              width: '100%',
              height: '48px',
              backgroundColor: '#FFFFFF',
              borderRadius: 12,
            }}
            onChange={handleChange}
            variant="outlined"
            name="title"
            placeholder="Title"
          >
            {STRINGS.OPENFLOW_TITLES.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </View>

        <TextInput
          title={'First Name *'}
          isfullwidth={true}
          type="text"
          error={nameError}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={(e) => {
            handleChange(e);
            setNameError(false);
          }}
          name="first_name"
          value={fieldsValue.first_name}
        />

        <TextInput
          title={'Last Name *'}
          isfullwidth={true}
          type="text"
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="last_name"
          value={fieldsValue.last_name}
        />

        <TextInput
          title={'Email Address *'}
          isfullwidth={true}
          type="email"
          value={fieldsValue.email?.toLowerCase()}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="email"
        />

        <TextInput
          title={'Contact Number *'}
          isfullwidth={true}
          type="tel"
          value={fieldsValue.number}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="number"
        />

        <TextInput
          title={'Landlord Registration Number'}
          isfullwidth={true}
          type="text"
          value={fieldsValue.license_number}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="license_number"
        />

        <TextInput
          title={'Address'}
          isfullwidth={true}
          type="text"
          value={fieldsValue.correspondece_address || ''}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="correspondece_address"
        />

        <TextInput
          title={'Post Code'}
          isfullwidth={true}
          type="text"
          value={fieldsValue.post_code || ''}
          wrapperStyle={{ width: '100%', marginBottom: 0 }}
          onChange={handleChange}
          name="post_code"
        />
      </View>

      <View style={toggleCardStyle}>
        <View>
          <SubHeading style={{ marginTop: 0, marginBottom: 0 }}>Is this lead landlord?</SubHeading>
          <Text style={helperTextStyle}>The lead landlord will be used as the main contact for this flow.</Text>
        </View>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="is_lead"
            name="is_lead"
            value={fieldsValue.is_lead}
            onChange={(e) => {
              setFieldValues({
                ...fieldsValue,
                is_lead: e.target.value == 'true' ? true : false,
              });
            }}
          >
            <FormControlLabel
              value={true}
              control={<Radio style={{ color: variables.heliotrope }} />}
              style={{ color: 'black' }}
              label="Yes"
            />
            <FormControlLabel
              value={false}
              control={<Radio style={{ color: variables.heliotrope }} />}
              style={{ color: 'black' }}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </View>

      <View style={{ ...toggleCardStyle, marginTop: 14 }}>
        <View>
          <SubHeading style={{ marginTop: 0, marginBottom: 0, color: '#B42318' }}>
            Is this address situated within {
              globalState?.property?.country === 'england_wales' ? 'England and Wales' :
                globalState?.property?.country === 'scotland' ? 'Scotland' :
                  globalState?.property?.country === 'northern_ireland' ? 'Northern Ireland' :
                    'England and Wales'
            }?
          </SubHeading>
          <Text style={helperTextStyle}>Choose No if the correspondence address is in {globalState?.property?.country === 'england_wales' ? 'Outside England and Wales' :
            globalState?.property?.country === 'scotland' ? 'Outside Scotland' :
              globalState?.property?.country === 'northern_ireland' ? 'Outside Northern Ireland' :
                'Outside England and Wales'}</Text>
        </View>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="isInEngland"
            name="is_england_address"
            value={fieldsValue.is_england_address}
            onChange={(e) => {
              setFieldValues({
                ...fieldsValue,
                is_england_address: e.target.value == 'true' ? true : false,
              });
            }}
          >
            <FormControlLabel
              value={true}
              control={<Radio style={{ color: variables.heliotrope }} />}
              style={{ color: 'black' }}
              label="Yes"
            />
            <FormControlLabel
              value={false}
              control={<Radio style={{ color: variables.heliotrope }} />}
              style={{ color: 'black' }}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </View>

      {!fieldsValue.is_england_address ? (
        <View
          style={{
            marginTop: 18,
            borderRadius: 16,
            border: '1px solid #F2DDCC',
            backgroundColor: '#FFF8F5',
            padding: 18,
          }}
        >
          <SubHeading style={{ marginTop: 0, marginBottom: 8, color: '#B54708' }}>
            Enter the correspondence address used for the non-{globalState?.property?.country === 'england_wales' ? 'england and wales' :
              globalState?.property?.country === 'scotland' ? 'scotland' :
                globalState?.property?.country === 'northern_ireland' ? 'northern ireland' :
                  'england and wales'} address.
          </SubHeading>
          <View style={gridStyle}>
            <TextInput
              title={'Correspondence Address'}
              isfullwidth={true}
              type="text"
              wrapperStyle={{ width: '100%', marginBottom: 0 }}
              onChange={handleChange}
              value={fieldsValue.correspondece_address_england}
              name="correspondece_address_england"
            />
            <TextInput
              title={'Post Code'}
              isfullwidth={true}
              type="text"
              wrapperStyle={{ width: '100%', marginBottom: 0 }}
              onChange={handleChange}
              value={fieldsValue.post_code_england}
              name="post_code_england"
            />
            <TextInput
              title={'Email Address'}
              isfullwidth={true}
              type="email"
              value={fieldsValue.email_england?.toLowerCase()}
              wrapperStyle={{ width: '100%', marginBottom: 0 }}
              onChange={handleChange}
              name="email_england"
            />
            <TextInput
              title={'Contact Number'}
              isfullwidth={true}
              type="tel"
              value={fieldsValue.number_england}
              wrapperStyle={{ width: '100%', marginBottom: 0 }}
              onChange={handleChange}
              name="number_england"
            />
          </View>
        </View>
      ) : null}

      <View
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 12,
          marginTop: 22,
          flexDirection: isPhone ? 'column' : 'row',
        }}
      >
        <Button
          type="stripe"
          onClick={() => _closeForm()}
          title="Cancel"
          style={{
            marginTop: 0,
            marginBottom: 0,
            color: variables.red,
            borderColor: '#FECACA',
            backgroundColor: '#FFF',
            minWidth: isPhone ? '100%' : 150,
          }}
        />
        <Button
          type="stripe"
          onClick={() => _addLandlord()}
          title={editingLandlordIndex !== null ? 'Update Landlord' : 'Save Landlord'}
          style={{
            marginTop: 0,
            marginBottom: 0,
            borderColor: '#2E90FA',
            backgroundColor: '#2E90FA',
            color: '#FFFFFF',
            minWidth: isPhone ? '100%' : 170,
          }}
        />
      </View>
    </CardBox>
  );
  const renderMakeLeadModalBody = () => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <Text style={{ color: '#111827', marginBottom: 16 }}>
        Do you wish to make this landlord as Lead Landlord
      </Text>
      <TlyfeButtonWrapper>
        <Button
          onClick={() => {
            setLandlords(MakeLeadFunct(landlords, mailToUpdateAsLead));
            setClosePopup(false);
            // setConfirm(true)
          }}
          title={'Yes'}
          type="stripe"
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setClosePopup(false);
          }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
      <br /> <br />
      <RowContainer>
        <Text style={{ color: '#111827' }}>Please Note</Text>
        <Text style={{ color: '#111827' }}>
          If you make landlord the Lead landlord any other landlord has been assigned as lead landlord would no longer
          be the Lead landlord
        </Text>
      </RowContainer>
    </View>
  );
  const MakeLeadFunct = (arrayData, emailTomakeLead) => {
    const data = arrayData.map((elem) => ({
      ...elem,
      is_lead: emailTomakeLead === elem?.email ? true : false,
    }));
    return data;
  };
  const toggleLead = (arr, index) => {
    return arr.map((item, i) => ({
      ...item,
      is_lead: i === index ? true : false
    }));
  };
  const deleteFlow = (arr, index) => {
    return arr.map((item, i) => ({
      ...item,
      remove_from_flow: i === index ? true : false
    }));
  };
  const sectionCardStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E4EAF5',
    borderRadius: 20,
    boxShadow: '0 12px 28px rgba(21, 49, 102, 0.08)',
    padding: isPhone ? 18 : 24,
    marginTop: 18,
  };
  const sectionHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: isPhone ? 'flex-start' : 'center',
    gap: 12,
    marginBottom: 18,
    flexDirection: isPhone ? 'column' : 'row',
  };
  const titleBlockStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  };
  const badgeStyle = {
    alignSelf: 'flex-start',
    borderRadius: 999,
    padding: '6px 12px',
    backgroundColor: '#EEF4FF',
    color: '#2E90FA',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.2,
  };
  const helperTextStyle = {
    color: '#667085',
    fontSize: 13,
    lineHeight: '18px',
    marginTop: 4,
  };
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: isPhone ? '1fr' : 'repeat(2, minmax(0, 1fr))',
    gap: 16,
  };
  const fieldWrapStyle = {
    width: '100%',
    justifyContent:"flex-end"
  };
  const labelStyle = {
    fontSize: 13,
    fontWeight: 700,
    color: '#153166',
    marginBottom: 8,
    display: 'block',
  };
  const toggleCardStyle = {
    marginTop: 18,
    borderRadius: 16,
    border: '1px solid #E4EAF5',
    backgroundColor: '#F8FAFF',
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexDirection: isPhone ? 'column' : 'row',
  };
  const listShellStyle = {
    marginTop: 18,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E4EAF5',
    borderRadius: 20,
    boxShadow: '0 12px 28px rgba(21, 49, 102, 0.06)',
    padding: isPhone ? 18 : 22,
  };
  console.log("gggggg", globalState)
  return (
    <Container>
      <CardWrapper>
        <ProgressCircle props={props} />
        {/* <ListItem
          type={'complete'}
          title={'Landlord & Property Documentation'}
          description={
            'Please ensure all details are correct so that all documentation, certificates and compliance requirements are correct. '
          }
          // icon={DOC_ICON}
          showPropertyCard
        /> */}
        {/* <Button
          type="stripe"
          onClick={() => history.push("/dashboard/rent/edit/" + flowId)}
          title={`Edit`}
          style={{
            borderColor: "#90C418",
            alignSelf: "flex-end",
            marginTop: 20,
          }}
        /> */}
        <BackComponent
          id={flowId}
          isComplete={globalState?.doc_status === 1 ? true : false}
          flowtype="doc_status"
        />

        <CardBox
          hasShadow={true}
          hasBorderRadius={true}
          style={sectionCardStyle}
          backColor="#FFFFFF"
          borderColor="#E4EAF5"
        >
          <View style={sectionHeaderStyle}>
            <View style={titleBlockStyle}>
              <SubHeading style={{ color: variables.purple, marginTop: 0, marginBottom: 0 }}>
                Landlord Information
              </SubHeading>
              <Text style={helperTextStyle}>
                Add the people responsible for this property and mark the lead landlord for correspondence.
              </Text>
            </View>
            <Text style={badgeStyle}>
              {landlords?.length ? `${landlords.length} landlord${landlords.length === 1 ? '' : 's'}` : 'No landlords yet'}
            </Text>
          </View>

          <View style={listShellStyle}>
            <View
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: isPhone ? 'column' : 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 18,
              }}
            >
              <Button
                type="stripe"
                onClick={() => {
                  setEditingLandlordIndex(null);
                  setFieldValues(landlordModal);
                  setShowAddLandLord(true);
                }}
                title={`${landlords?.length > 0 ? 'Add Another Landlord' : 'Add Landlord'}`}
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  borderColor: '#90C418',
                  backgroundColor: '#F4F9EA',
                  color: '#3A5F0B',
                  minWidth: isPhone ? '100%' : 220,
                  paddingHorizontal: 18,
                }}
              />
            </View>

            {/* Info Banner matching agent */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#EBF5FF',
                border: '1px solid #BFDBFE',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '20px',
                gap: '10px',
                color: '#1E40AF',
                fontSize: '13px',
                lineHeight: '20px',
                fontFamily: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              }}
            >
              <InfoOutlinedIcon style={{ fontSize: 20, color: '#2563EB', flexShrink: 0 }} />
              <span>
                Landlord information is requested, in order to auto generate the tenancy agreement and prescribed information.
              </span>
            </div>

            {landlords && landlords.length ? (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  alignContent: 'flex-start',
                }}
              >
                {landlords.map((item, landlordIndex) => (
                  <View
                    key={item.open_flow_landlord_id || item.email || landlordIndex}
                    style={{
                      width: isPhone ? '100%' : 340,
                      minWidth: isPhone ? '100%' : 300,
                      maxWidth: isPhone ? '100%' : 360,
                      marginRight: isPhone ? 0 : 20,
                      marginBottom: 20,
                    }}
                  >
                    <LandlordCard
                      landlord={item}
                      flowId={flowId}
                      handleMakeLead={(landlordItem) => {
                        dispatch(
                          tenantActions.makeLead(
                            landlordItem?.open_flow_landlord_id || item?.open_flow_landlord_id,
                            () => {
                              showSuccesToast('Landlord marked as lead successfully!');
                              fetchFlows();
                            },
                            true,
                            flowId
                          )
                        );
                      }}
                      handleEdit={() => handleEditLandlord(item, landlordIndex)}
                      handleDelete={() => {
                        setSelectedLandlordToDelete(item);
                        setShowDeleteLandlordModal(true);
                      }}
                    />
                  </View>
                ))}
              </View>
            ) : (
              <View
                style={{
                  borderRadius: 18,
                  border: '1px dashed #CBD5E1',
                  backgroundColor: '#F8FAFC',
                  padding: 22,
                  textAlign: 'center',
                  color: '#667085',
                  lineHeight: '22px',
                }}
              >
                No landlords have been added yet. Use the button below to add the first landlord and set the lead contact.
              </View>
            )}
          </View>
        </CardBox>

        {showAddLandLord ? (
          <OpenFlowModal
            showModal={showAddLandLord}
            setShowModal={setShowAddLandLord}
            modalBody={displayAddLandLord()}
            showFooter={false}
            modalHeading={editingLandlordIndex !== null ? 'Edit Landlord' : landlords?.length ? 'Add Another Landlord' : 'Add Landlord'}
            modalWidth={isPhone ? 360 : 860}
          />
        ) : null}

        {/* Dialog: Delete Landlord Confirmation */}
        <Dialog
          open={showDeleteLandlordModal}
          onClose={() => {
            setShowDeleteLandlordModal(false);
            setSelectedLandlordToDelete(null);
          }}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle style={{ fontWeight: '600' }}>Are you sure?</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#475569' }}>
              Are you sure, You want to remove{' '}
              {selectedLandlordToDelete
                ? `${selectedLandlordToDelete?.first_name?.toUpperCase() || ''} ${selectedLandlordToDelete?.last_name?.toUpperCase() || ''}`.trim()
                : 'this'}{' '}
              landlord.
            </DialogContentText>
            <div
              style={{
                marginTop: 14,
                backgroundColor: '#FFFBEB',
                border: '1px solid #FDE68A',
                borderRadius: 8,
                padding: '10px 14px',
                color: '#92400E',
                fontSize: 12,
              }}
            >
              <b>Please Note:</b> Once you remove this landlord, you cannot undo this change.
            </div>
          </DialogContent>
          <DialogActions style={{ padding: '16px 24px' }}>
            <MuiButton
              onClick={() => {
                setShowDeleteLandlordModal(false);
                setSelectedLandlordToDelete(null);
              }}
              variant="outlined"
              color="default"
              style={{ textTransform: 'none' }}
            >
              No
            </MuiButton>
            <MuiButton
              onClick={() => {
                if (selectedLandlordToDelete?.open_flow_landlord_id) {
                  dispatch(
                    tenantActions.deleteUser(
                      selectedLandlordToDelete.open_flow_landlord_id,
                      () => {
                        showSuccesToast('Landlord deleted successfully!');
                        fetchFlows();
                        setShowDeleteLandlordModal(false);
                        setSelectedLandlordToDelete(null);
                      },
                      true,
                      flowId
                    )
                  );
                }
              }}
              variant="contained"
              style={{
                backgroundColor: '#EF4444',
                color: '#FFFFFF',
                textTransform: 'none',
              }}
            >
              Yes
            </MuiButton>
          </DialogActions>
        </Dialog>
        <CertificatesScreen flowId={flowId} />
        {globalState?.open_flow_certificates?.length ?
          <DocStatusTable flowId={flowId} open_flow_certificates={globalState?.open_flow_certificates} /> : null}
        <LineSeperator />
        <React.Fragment style={{}}>


          {globalState?.open_flow_certificates?.length ? <BottomButton
            buttonText={'Send Documents'}
            onRightClick={() => {
              let obj = {
                certificates: convertToArray(gasSafteyCer, epcCer, eicCer, patCer, lisc),
                send_to_tenant: true,
                flow_id: flowId,
              };
              dispatch(tenantActions.sendCer(flowId, (data) => {
                showSuccesToast("Request send successfully!")
              }));

            }}
          /> : null}
          {/* <BottomButton
            buttonText={modalState?.send_to_tenant ? 'Update and Send' : 'Save and Send'}
            rightBtnTiltle={'Save & Continue'}
            onRightClick={() => { setSuccessModal(true);
            }}
            onContinue={() => _save('backNavigation', true, { send_to_tenant: true })}
          /> */}
        </React.Fragment>
      </CardWrapper>
      {showNoticeModal && (
        <OpenFlowModal
          showModal={showNoticeModal}
          setShowModal={setShowNoticeModal}
          modalBody={renderModal}
          showFooter={false}
          modalHeading={'Documents'}
          onModalStatusChnage={(data) => setModal(data)}
          modalSubHeading={``}
          modalWidth={600}
        />
      )}

      {showSuccessModal ? <SaveandContinueModal
        visible={showSuccessModal}
        heading={'Documents'}
        modalState={modalState}
        showNote
        subHeading={[
          `Have you clicked "save and send documents"?`,
          `Remember,  if you don't do this, your tenants do not receive the documents to thier tlyfe app.`,
        ]}
        onCancelPress={() => setSuccessModal(false)}
        onOkPress={(data) => {
          data.send_to_tenant = true;
          _save('backNavigation', true, data);
        }}
      /> : null}
    </Container>
  );
};

export default DrawerHoc({
  Component: PropertyDocumentation,
  showBackButton: true,
  backNavigation: "CurrentOnboards"
});
